export const POST_APPLY_STEPS = [
  'medical-release-consent',
  'medical-release-signature',
  'warm-transfer',
  'patient-call-to-site',
  'why-apply',
  'save-study-team-contact',
  'screening-visit-availability',
  'patient-navigator-agent',
  'share-story',
  'registry',
  'guardian',
] as const

export type PostApplyStep = (typeof POST_APPLY_STEPS)[number]
